import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedInvoice'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_INVOICE()
  },
  methods: {
    ...mapActions([
      'actionRemoveInvoice'
    ]),
    ...mapMutations([
      'SET_SELECTED_INVOICE'
    ]),
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    removeInvoice () {
      const { paymentDate, settled } = this.getterSelectedInvoice

      if ((paymentDate && paymentDate === '0001-01-01T00:00:00') && (Object.prototype.hasOwnProperty.call(this.getterSelectedInvoice, 'settled') && !settled)) {
        this.isLoading = true

        this.actionRemoveInvoice(this.getterSelectedInvoice)
          .then(() => {
            this.isLoading = false

            this.closeModal()
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Não foi possível excluir o pagamento, tente novamente mais tarde!',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Não é possível remover este pagamento!',
          type: 'warning'
        })
      }
    }
  }
}
